module.exports = __webpack_public_path__ + "c_static/img/2-2淘宝-足迹.6e8d8ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/2-2淘宝-足迹.jpg
// module id = XJeQ
// module chunks = 33